import React from  "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Login from "./containers/Login";
import NotFound from "./containers/NotFound";
import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import ResetPassword from "./containers/ResetPassword";
import UnauthenicatedRoute from "./components/UnauthenticatedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import Settings from "./containers/Settings";
import ChangePassword from "./containers/ChangePassword";
import ChangeEmail from "./containers/ChangeEmail";

export default ({ childProps }) => 
    <Switch>
        <AppliedRoute path="/" exact component={Home} props={childProps} />
        <UnauthenicatedRoute path="/login" exact component={Login} props={childProps} />
        <UnauthenicatedRoute path="/signup" exact component={Signup} props={childProps} />
        <UnauthenicatedRoute path="/login/reset" exact component={ResetPassword} props={childProps}></UnauthenicatedRoute>
        <AuthenticatedRoute path="/settings" exact component={Settings} props={childProps}></AuthenticatedRoute>
        <AuthenticatedRoute path="/settings/password" exact component={ChangePassword} props={childProps}></AuthenticatedRoute>
        <AuthenticatedRoute path="/settings/email" exact component={ChangeEmail} props={childProps}></AuthenticatedRoute>
        <Route component={NotFound} />
    </Switch>;